import axios from "axios";
import authAPI from "@/api/auth";
import VueJwtDecode from "vue-jwt-decode";
import moment from "moment-timezone";

if (!process.env.VUE_APP_IS_WEB) {
  var argon2 = require("argon2");
}

const auth = {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "",
    /** MERCURE Token */
    mercureJwtToken: localStorage.getItem("mercure-jwt-token") || "",
    isAuthenticatedDesktop: false,
    // to authenticate when syncing
    username: "",
    userPassword: "",
    anotherRefreshTokenOngoing: false,
    isMercureJwtTokenInvalid: false,
  },
  getters: {
    // TODO: FIXME: authentication in desktop app
    isAuthenticated(state) {
      if (!process.env.VUE_APP_IS_WEB) {
        // return true;
        return state.isAuthenticatedDesktop;
      } else {
        return !!state.token;
      }
    },
    isAuthenticatedForSyncing(state) {
      return !!state.token;
    },
    /** MERCURE Token */
    mercureJwtToken(state) {
      return state.mercureJwtToken;
    },
    isAuthenticatedForMercure(state) {
      return !!state.mercureJwtToken;
    },
    isAnotherRefreshTokenOngoing(state) {
      return state.anotherRefreshTokenOngoing;
    },
    isMercureJwtTokenInvalid(state) {
      return state.isMercureJwtTokenInvalid;
    },
  },
  mutations: {
    /** web + syncing + mercure */
    auth(state, tokens) {
      var decodedToken = VueJwtDecode.decode(tokens.token);

      state.token = tokens.token;
      state.mercureJwtToken = decodedToken.mercureJwtToken;

      localStorage.setItem("token", tokens.token);
      localStorage.setItem("refresh_token", tokens.refreshToken);
      localStorage.setItem("mercure-jwt-token", decodedToken.mercureJwtToken);
      if (process.env.VUE_APP_IS_WEB) {
        localStorage.setItem("userId", decodedToken.userId);
        localStorage.setItem("username", decodedToken.username);
        localStorage.setItem("email", decodedToken.email ? decodedToken.email : "");
        localStorage.setItem("agencyId", decodedToken.agencyId);
        localStorage.setItem("timezone", decodedToken.timezone);
        moment.tz.setDefault(decodedToken.timezone);
      }

      axios.defaults.headers.common["Authorization"] = "Bearer " + tokens.token;
    },
    deauth(state) {
      state.token = "";
      state.mercureJwtToken = "";

      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("mercure-jwt-token");
      if (process.env.VUE_APP_IS_WEB) {
        localStorage.removeItem("userId");
        localStorage.removeItem("username");
        localStorage.removeItem("email");
        localStorage.removeItem("agencyId");
      }

      delete axios.defaults.headers.common["Authorization"];
      this.dispatch("entities/deleteAll");
    },
    /** desktop ... */
    auth_desktop(state, data) {
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("appId", data.appId);
      localStorage.setItem("username", data.username);
      localStorage.setItem("agencyId", data.agencyId);
      localStorage.setItem("timezone", data.timezone);
      moment.tz.setDefault(VueJwtDecode.decode(tokens.token).timezone);

      // needed when syncing
      state.username = data.username;
      state.userPassword = data.userPassword;
    },
    deauth_desktop(state) {
      localStorage.removeItem("userId");
      localStorage.removeItem("appId");
      localStorage.removeItem("username");
      localStorage.removeItem("agencyId");

      // needed when syncing
      state.token = "";
      state.mercureJwtToken = "";
      state.username = "";
      state.userPassword = "";
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");

      state.isAuthenticatedDesktop = false;
      this.dispatch("entities/deleteAll");
    },
    set_auth(state, value) {
      state.isAuthenticatedDesktop = value;
    },
    set_another_refresh_token_ongoing(state, value) {
      state.anotherRefreshTokenOngoing = value;
    },
    set_is_jwt_mercure_token_invalid(state, value) {
      state.isMercureJwtTokenInvalid = value;
    },
  },
  actions: {
    /** Auth Web */
    login({ commit }, loginData) {
      return new Promise((resolve, reject) => {
        authAPI
          .login(loginData)
          .then(res => {
            const tokens = {
              token: res.data.token,
              refreshToken: res.data.refresh_token,
            };
            commit("auth", tokens);
            resolve(res);
          })
          .catch(err => {
            commit("deauth");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("deauth");
        resolve();
      });
    },
    tokenRefresh({ getters, commit }) {
      const anotherRefreshTokenOngoing = getters.isAnotherRefreshTokenOngoing;
      if (!anotherRefreshTokenOngoing) {
        commit("set_another_refresh_token_ongoing", true);
        return new Promise((resolve, reject) => {
          authAPI
            .tokenRefresh()
            .then(res => {
              const tokens = {
                token: res.data.token,
                refreshToken: res.data.refresh_token,
              };
              commit("auth", tokens);
              commit("set_another_refresh_token_ongoing", false);
              resolve(res);
            })
            .catch(err => {
              commit("deauth");
              commit("set_another_refresh_token_ongoing", false);
              reject(err);
            });
        });
      }
    },
    /** FORGOT PASSWORD */
    async checkEmail({ commit }, email) {
      if (!process.env.VUE_APP_IS_WEB) {
        var UserMW = require("@/middlewares/User").default;
        await UserMW.CHECK_USER_BY_EMAIL_DB(email).catch(err => {
          console.error(err);
          return Promise.reject(err);
        });
      }

      return new Promise((resolve, reject) => {
        authAPI
          .checkEmail(email)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    async checkUsername({ commit }, username) {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: ..
      }

      return new Promise((resolve, reject) => {
        authAPI
          .checkUsername(username)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    checkVerificationCode({ commit }, verificationCode) {
      return new Promise((resolve, reject) => {
        authAPI
          .checkVerificationCode(verificationCode)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    setPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        authAPI
          .setPassword(payload.verificationCode, payload.password)
          .then(res => {
            if (!process.env.VUE_APP_IS_WEB) {
              var UserMW = require("@/middlewares/User").default;
              UserMW.SET_USER_PASSWORD_DB(payload.password)
                .then(() => {
                  resolve(res);
                })
                .catch(err => {
                  console.error(err);
                  reject(err);
                });
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    /** Reset Password */
    AGResetUserPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        authAPI
          .AGResetUserPassword(payload.username, payload.userType, payload.password)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    setAuthentication({ commit }, value) {
      commit("set_auth", value);
    },
    // call to initialize application
    checkUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        authAPI
          .checkUser(payload.username, payload.password)
          .then(resCheckUser => {
            var UserMW = require("@/middlewares/User").default;

            UserMW.ADD_USER_DB(resCheckUser.data, payload.username, payload.password)
              .then(resAddUser => {
                const data = {
                  userId: resAddUser.id,
                  appId: resCheckUser.data.app_id,
                  agencyId: resCheckUser.data.agency_id,
                  // to authenticate when syncing
                  username: payload.username,
                  userPassword: payload.password,
                };
                commit("auth_desktop", data);
                resolve(resCheckUser);
              })
              .catch(err => {
                console.log("err", err);
                commit("deauth_desktop");
                reject(err);
              });
          })
          .catch(err => {
            console.log("err", err);
            commit("deauth_desktop");
            reject(err);
          });
      });
    },
    /** LOGIN DESKTOP */
    async loginDesktop({ commit }, loginData) {
      var UserMW = require("@/middlewares/User").default;

      var success = false;
      var message = "";

      var user = null;
      await UserMW.GET_USER_FROM_DB()
        .then(res => {
          if (res) {
            user = res;
          } else {
            return Promise.reject("There is no user in the database.");
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });

      try {
        if (
          (await argon2.verify(user.password, loginData.password)) &&
          user.username == loginData.username
        ) {
          success = true;
          message = "Authentication Succeeded.";
        } else {
          message = "Authentication Failed.";
        }
      } catch (err) {
        message = err;
      }

      return new Promise((resolve, reject) => {
        if (success) {
          const data = {
            userId: user.id,
            appId: user.app_id,
            agencyId: user.agency_id,
            // to authenticate when syncing
            username: loginData.username,
            userPassword: loginData.password,
          };
          commit("auth_desktop", data);
          resolve({
            status: "success",
            message: message,
          });
        } else {
          commit("deauth_desktop");
          reject({
            status: "error",
            message: message,
          });
        }
      });
    },
    logoutDesktop({ commit }) {
      return new Promise((resolve, reject) => {
        commit("deauth_desktop");
        resolve();
      });
    },
    setMercureJwtTokenStatus({ commit }, value) {
      commit("set_is_jwt_mercure_token_invalid", value);
    },
  },
};

export default auth;
